import { ReactNode } from "react";
import { useLocation } from "@/lib/router-compat";
import { SectionErrorBoundary } from "@/components/SectionErrorBoundary";

/**
 * Wraps the top-level `<Routes>` element so a thrown render error on
 * any single page shows an inline error card instead of blanking the
 * whole app. Keyed by `pathname` so navigating to a different route
 * automatically resets the boundary — users don't get stuck on a stale
 * error screen after they click a link in the nav.
 *
 * The outer `<ErrorBoundary>` in `App.tsx` is the last-resort catcher
 * for anything thrown above the router (provider crashes, etc.). This
 * one exists to keep route failures recoverable without a full reload.
 */
export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  const location = useLocation();
  return (
    <SectionErrorBoundary key={location.pathname} sectionName="Page">
      {children}
    </SectionErrorBoundary>
  );
}
